// social media payment calculation: not used at the moment
export function calculate_payment_amount(
    donate_like_history=true,
    donate_search_history=true,
    donate_share_history=true,
    donate_session_times=true,
    donate_favorites=true,
    donate_following=true,
    donate_followers=true,
    donate_comments=true,
    donate_comments_text=true,
    donate_ads=true,
    donate_settings=true,
    survey_completed=false,
) {

    const WATCH_HISTORY = 5;
    const OTHER_AMOUNT = 1;
    const SURVEY_AMOUNT = 0;

    var payment_amount = WATCH_HISTORY;

    const optional_fields = [donate_like_history, donate_search_history, donate_share_history, donate_session_times, donate_favorites, donate_followers, donate_following, donate_ads, donate_settings];
    for (var i = 0; i < optional_fields.length; i++){ 
        if(optional_fields[i]===true){
            // console.log(optional_fields[i]);
            payment_amount+=OTHER_AMOUNT
        }
    }
    if(donate_comments === true){
        payment_amount += OTHER_AMOUNT;
        if (donate_comments_text === true){
            payment_amount += OTHER_AMOUNT;
        }
    }

    if (survey_completed===true) {
        payment_amount+=SURVEY_AMOUNT;
    }

    return payment_amount;
}


// TODO: Make the payment calculations safe using objects instead of positional arguments
export function calculate_payment_amount_chatgpt(
    donation_GPTSharedConversations=false,
    donation_GPTMessageFeedbacks=false,
    donation_GPTUploadedImages = false,
    survey_completed=true,
) {

    const GPT_CONVERSATIONS = 5;
    const OTHER_AMOUNT = 1;
    const UploadedImages = 3;
    const SURVEY_AMOUNT = 0;

    var payment_amount = GPT_CONVERSATIONS;

    const optional_fields = [
        donation_GPTSharedConversations,
        donation_GPTMessageFeedbacks
    ];

    if (donation_GPTUploadedImages===true){
        payment_amount+=UploadedImages;
    }

    for (var i = 0; i < optional_fields.length; i++){ 
        if (optional_fields[i]===true) {
            payment_amount += OTHER_AMOUNT;
        }
    }

    if (survey_completed===true) {
        payment_amount += SURVEY_AMOUNT;
    }

    return payment_amount;

}

// TODO: Make the payment calculations safe using objects instead of positional arguments
// gemini payment calculation
export function calculate_payment_amount_gemini(
    donation_GoogleSearchActivity = false,
    donation_GeminiAIMode = false,
    donation_GeminiUploadedFiles = false,
    survey_completed = true
    ) {
    const GEMINI_CONVERSATIONS_BASE = 5; // mandatory
    const OTHER_AMOUNT = 1;              // per optional category
    const SURVEY_AMOUNT = 0;             // no payment for survey --> paid directly using base payment in Prolific 
    const UPLOADED_FILES_AMOUNT = 2;   // for uploaded files optional category

    let payment_amount = GEMINI_CONVERSATIONS_BASE;

    if (donation_GoogleSearchActivity) payment_amount += OTHER_AMOUNT;
    if (donation_GeminiAIMode) payment_amount += OTHER_AMOUNT;
    if (donation_GeminiUploadedFiles) payment_amount += UPLOADED_FILES_AMOUNT;

    if (survey_completed) payment_amount += SURVEY_AMOUNT;

    return payment_amount;
}


// TODO: Make the payment calculations safe using objects instead of positional arguments
// claude payment calculation
export function calculate_payment_amount_claude(
    donation_ClaudeProjects=false,
    survey_completed=true,
) {

    const CLAUDE_CONVERSATIONS_BASE = 5;
    const OTHER_AMOUNT = 1;
    const SURVEY_AMOUNT = 0;

    var payment_amount = CLAUDE_CONVERSATIONS_BASE;

    if (donation_ClaudeProjects) payment_amount += OTHER_AMOUNT;

    if (survey_completed) payment_amount += SURVEY_AMOUNT;
    

    return payment_amount;
}

// TODO: 
// deepseek payment calculation 
export function calculate_payment_amount_deepseek(
    survey_completed=true,
    // note: no optional fields for deepseek at the moment   
    ){
        const DEEPSEEK_CONVERSATIONS_BASE = 5;
        const SURVEY_AMOUNT = 0;

        var payment_amount = DEEPSEEK_CONVERSATIONS_BASE;

        if (survey_completed) payment_amount += SURVEY_AMOUNT;

        return payment_amount;

    } 

// mistral payment calculation 
export function calculate_payment_amount_mistral(
    uploaded_files=false,
    survey_completed=true,
     
    ){
        const MISTRAL_CONVERSATIONS_BASE = 5;
        const SURVEY_AMOUNT = 0;
        const UPLOADED_FILES_AMOUNT = 1;

        var payment_amount = MISTRAL_CONVERSATIONS_BASE;

        if (uploaded_files) payment_amount += UPLOADED_FILES_AMOUNT;

        if (survey_completed) payment_amount += SURVEY_AMOUNT;

        return payment_amount;

    }


// grok payment calculation
export function calculate_payment_amount_grok(
    grok_projects=false,
    grok_tasks=false,
    grok_mediaPosts=false,
    survey_completed=true,
    // note: no optional fields for grok at the moment   
    ){
        const GROK_CONVERSATIONS_BASE = 5;
        const OTHER_AMOUNT = 1;
        const SURVEY_AMOUNT = 0;

        var payment_amount = GROK_CONVERSATIONS_BASE;

        if (grok_projects) payment_amount += OTHER_AMOUNT;
        if (grok_tasks) payment_amount += OTHER_AMOUNT;
        if (grok_mediaPosts) payment_amount += OTHER_AMOUNT;

        if (survey_completed) payment_amount += SURVEY_AMOUNT;

        return payment_amount;

    }